import request from 'superagent'
import types from '../types'
import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let apiUrl = `${protocol}//${hostname}:${api_port}/api`
if (api_port === '') {
  apiUrl = `${protocol}//${hostname}/api`
}

const getLocationApplicationsRequested = () => ({
  type: types.GET_LOCATION_APPLICATIONS_REQUESTED,
  payload: null
})

const getLocationApplicationsFulfilled = (data: any) => ({
  type: types.GET_LOCATION_APPLICATIONS_FULFILLED,
  payload: data
})

const getLocationApplicationsRejected = (error: any) => ({
  type: types.GET_LOCATION_APPLICATIONS_REJECTED,
  payload: error
})


export const getLocationApplications = (id: number, eid: string, token: string) => {
  return (dispatch: any) => {
    dispatch(getLocationApplicationsRequested())
    request
      .post(`${apiUrl}/locationApplications/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send({ eid })
      .then((response) => {
        dispatch(getLocationApplicationsFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getLocationApplicationsRejected(error))
      })
  }
}

const getLocationApplicationRequested = () => ({
  type: types.GET_LOCATION_APPLICATION_REQUESTED,
  payload: null
})

const getLocationApplicationFulfilled = (data: any) => ({
  type: types.GET_LOCATION_APPLICATION_FULFILLED,
  payload: data
})

const getLocationApplicationRejected = (error: any) => ({
  type: types.GET_LOCATION_APPLICATION_REJECTED,
  payload: error
})


export const getLocationApplication = (id: number, eid: string, token: string) => {
  return (dispatch: any) => {
    dispatch(getLocationApplicationRequested())
    request
      .post(`${apiUrl}/locationApplication/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send({ eid })
      .then((response) => {
        dispatch(getLocationApplicationFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getLocationApplicationRejected(error))
      })
  }
}

const addLocationApplicationRequested = () => ({
  type: types.ADD_LOCATION_APPLICATION_REQUESTED,
  payload: null
})

const addLocationApplicationFulfilled = (data: any) => ({
  type: types.ADD_LOCATION_APPLICATION_FULFILLED,
  payload: data
})

const addLocationApplicationRejected = (error: any) => ({
  type: types.ADD_LOCATION_APPLICATION_REJECTED,
  payload: error
})

export const addLocationApplication = (data: { applicationType: string; '12BedCertification': string }, organizationId: number, id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(addLocationApplicationRequested())
    request
      .post(`${apiUrl}/locationApplication/${organizationId}/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(addLocationApplicationFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(addLocationApplicationRejected(error))
      })
  }
}

const resetAddLocationApplication = () => ({
  type: types.ADD_LOCATION_APPLICATION_RESET,
  payload: null
})

export const resetLocationApplication = () => {
  return (dispatch: any) => {
    dispatch(resetAddLocationApplication())
  }
}

const updateLocationApplicationGeneralInfoRequested = () => ({
  type: types.UPDATE_LOCATION_APPLICATION_GENERAL_INFO_REQUESTED,
  payload: null
})

const updateLocationApplicationGeneralInfoRejected = (error: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_GENERAL_INFO_REJECTED,
  payload: error
})

const updateLocationApplicationGeneralInfoFulfilled = (data: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_GENERAL_INFO_FULFILLED,
  payload: data
})

export const updateLocationApplicationGeneralInfo = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(updateLocationApplicationGeneralInfoRequested())
    request
      .put(`${apiUrl}/locationApplication/generalInfo/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(updateLocationApplicationGeneralInfoFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateLocationApplicationGeneralInfoRejected(error))
      })
  }
}

const updateLocationApplicationContactInfoRequested = () => ({
  type: types.UPDATE_LOCATION_APPLICATION_CONTACT_INFO_REQUESTED,
  payload: null
})

const updateLocationApplicationContactInfoRejected = (error: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_CONTACT_INFO_REJECTED,
  payload: error
})

const updateLocationApplicationContactInfoFulfilled = (data: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_CONTACT_INFO_FULFILLED,
  payload: data
})

export const updateLocationApplicationContactInfo = (token: string, id: number, data: any, submitItem: boolean) => {
  return (dispatch: any) => {
    dispatch(updateLocationApplicationContactInfoRequested())
    request
      .put(`${apiUrl}/locationApplication/contactInfo/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send({
        ...data,
        submitItem
      })
      .then((response) => {
        dispatch(updateLocationApplicationContactInfoFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateLocationApplicationContactInfoRejected(error))
      })
  }
}

const updateLocationApplicationOrgInfoRequested = () => ({
  type: types.UPDATE_LOCATION_APPLICATION_ORG_INFO_REQUESTED,
  payload: null
})

const updateLocationApplicationOrgInfoRejected = (error: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_ORG_INFO_REJECTED,
  payload: error
})

const updateLocationApplicationOrgInfoFulfilled = (data: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_ORG_INFO_FULFILLED,
  payload: data
})

export const updateLocationApplicationOrgInfo = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(updateLocationApplicationOrgInfoRequested())
    request
      .put(`${apiUrl}/locationApplication/organizationalInfo/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(updateLocationApplicationOrgInfoFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateLocationApplicationOrgInfoRejected(error))
      })
  }
}

const updateLocationApplicationDisclosureQuestionsRequested = () => ({
  type: types.UPDATE_LOCATION_APPLICATION_DISCLOSURE_QUESTIONS_REQUESTED,
  payload: null
})

const updateLocationApplicationDisclosureQuestionsRejected = (error: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_DISCLOSURE_QUESTIONS_REJECTED,
  payload: error
})

const updateLocationApplicationDisclosureQuestionsFulfilled = (data: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_DISCLOSURE_QUESTIONS_FULFILLED,
  payload: data
})

export const updateLocationApplicationDisclosureQuestions = (token: string, id: number, data: any, submitItem: boolean) => {
  return (dispatch: any) => {
    dispatch(updateLocationApplicationDisclosureQuestionsRequested())
    request
      .put(`${apiUrl}/locationApplication/contactInfo/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send({
        ...data,
        submitItem
      })
      .then((response) => {
        dispatch(updateLocationApplicationDisclosureQuestionsFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateLocationApplicationDisclosureQuestionsRejected(error))
      })
  }
}

const updateLocationApplicationItemRequested = () => ({
  type: types.UPDATE_LOCATION_APPLICATION_ITEM_REQUESTED,
  payload: null
})

const updateLocationApplicationItemRejected = (error: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_ITEM_REJECTED,
  payload: error
})

const updateLocationApplicationItemFulfilled = (data: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_ITEM_FULFILLED,
  payload: data
})

export const updateLocationApplicationItem = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(updateLocationApplicationItemRequested())
    request
      .put(`${apiUrl}/locationApplicationItem/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(updateLocationApplicationItemFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateLocationApplicationItemRejected(error))
      })
  }
}

const updateLocationApplicationCertificationRequested = () => ({
  type: types.UPDATE_LOCATION_APPLICATION_CERTIFICATION_REQUESTED,
  payload: null
})

const updateLocationApplicationCertificationRejected = (error: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_CERTIFICATION_REJECTED,
  payload: error
})

const updateLocationApplicationCertificationFulfilled = (data: any) => ({
  type: types.UPDATE_LOCATION_APPLICATION_CERTIFICATION_FULFILLED,
  payload: data
})

export const updateLocationApplicationCertification = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(updateLocationApplicationCertificationRequested())
    request
      .put(`${apiUrl}/locationApplicationCertification/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(updateLocationApplicationCertificationFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateLocationApplicationCertificationRejected(error))
      })
  }
}

const submitLocationApplicationRequested = () => ({
  type: types.SUBMIT_LOCATION_APPLICATION_REQUESTED,
  payload: null
})

const submitLocationApplicationRejected = (error: any) => ({
  type: types.SUBMIT_LOCATION_APPLICATION_REJECTED,
  payload: error
})

const submitLocationApplicationFulfilled = (data: any) => ({
  type: types.SUBMIT_LOCATION_APPLICATION_FULFILLED,
  payload: data
})

export const submitLocationApplication = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(submitLocationApplicationRequested())
    request
      .post(`${apiUrl}/locationApplication/submit/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(submitLocationApplicationFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(submitLocationApplicationRejected(error))
      })
  }
}

const submitLocationCertificationItemsRequested = () => ({
  type: types.SUBMIT_LOCATION_CERTIFICATION_ITEMS_REQUESTED,
  payload: null
})

const submitLocationCertificationItemsRejected = (error: any) => ({
  type: types.SUBMIT_LOCATION_CERTIFICATION_ITEMS_REJECTED,
  payload: error
})

const submitLocationCertificationItemsFulfilled = (data: any) => ({
  type: types.SUBMIT_LOCATION_CERTIFICATION_ITEMS_FULFILLED,
  payload: data
})

export const submitLocationCertificationItems = (token: string, id: number, data: any) => {
  return (dispatch: any) => {
    dispatch(submitLocationCertificationItemsRequested())
    request
      .post(`${apiUrl}/locationApplicationCertification/submit/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(submitLocationCertificationItemsFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(submitLocationCertificationItemsRejected(error))
      })
  }
}